export default "__VITE_ASSET__ae538387__"